import { render, staticRenderFns } from "./FormNewsCard.vue?vue&type=template&id=0875fcb4&scoped=true"
import script from "./FormNewsCard.vue?vue&type=script&lang=js"
export * from "./FormNewsCard.vue?vue&type=script&lang=js"
import style0 from "./FormNewsCard.vue?vue&type=style&index=0&id=0875fcb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875fcb4",
  null
  
)

export default component.exports